<script setup lang="ts">
import { CircleAlert, CircleCheck, TriangleAlert, X } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'

import type { Notice } from '@/types/monitor'

const { t } = useI18n()

defineProps<{ notices: Notice[] }>()
defineEmits<{ dismiss: [id: number] }>()

function icon(level: Notice['level']) {
  if (level === 'error') return CircleAlert
  if (level === 'warning') return TriangleAlert
  return CircleCheck
}
</script>

<template>
  <div class="toast-stack" aria-live="polite">
    <TransitionGroup name="toast">
      <article v-for="notice in notices" :key="notice.id" class="toast" :class="`toast--${notice.level}`">
        <component :is="icon(notice.level)" :size="17" />
        <p>{{ notice.message }}</p>
        <button type="button" :title="t('common.close')" @click="$emit('dismiss', notice.id)"><X :size="14" /></button>
      </article>
    </TransitionGroup>
  </div>
</template>
